import { GAME_ID, REDUX_ACTIONS } from '../data/constants';

const initialState = {
  // Round-play state: reset at the start of each round.
  questionIndex: 0,
  itemsInRound: 0,
  questionsCorrect: 0,
  progressAmount: 0,
  // Session state: persists across rounds within a game session.
  isOnboarded: false,
};

// One reducer per game (registered under newGameReducer in the app store).
// Holds the round summary that reporting + quest progress read back, plus the onboarding flag.
// Transient per-item state (first-try tracking, Alex animation) lives in StandardScreen.
// Action types aren't namespaced, so ignore actions originating from other games.
const newGameReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...state,
        itemsInRound: payload.itemsInRound,
        questionIndex: 0,
        questionsCorrect: 0,
        progressAmount: 0,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        progressAmount: state.questionIndex === state.itemsInRound - 1
          ? 100
          : state.progressAmount + (100 / state.itemsInRound),
        questionIndex: Math.min(state.questionIndex + 1, state.itemsInRound - 1),
      };

    case REDUX_ACTIONS.INCREMENT_QUESTIONS_CORRECT:
      return { ...state, questionsCorrect: state.questionsCorrect + 1 };

    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return { ...state, isOnboarded: true };

    default:
      return state;
  }
};

export default newGameReducer;
